export default function formatEmpty(value: unknown): string | undefined {
  return value === undefined || value === null ? "" : undefined;
}
